"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCaseNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'CHANGE-CASE';
class ChangeCaseNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            let outputVal;
            const stringVal = params.inputString || null;
            if (stringVal) {
                //default value
                if (!this.config.caseType) {
                    return { output: stringVal.toUpperCase() };
                }
                switch (this.config.caseType) {
                    case 'UPPERCASE':
                    case 'ALL CAPS':
                        outputVal = stringVal.toUpperCase();
                        break;
                    case 'LOWERCASE':
                    case 'lowercase':
                        outputVal = stringVal.toLowerCase();
                        break;
                    case 'CAPITALCASE':
                    case 'Capitalization':
                        outputVal = this.toCaptialCase(stringVal);
                        break;
                    case 'SENTENCECASE':
                    case 'Sentence case':
                        outputVal = this.capitalizeAfterPeriods(stringVal.toLowerCase());
                        break;
                    case 'Title Case': //Title case is weird and not super well defined, and in quick searching I didn't find a library that has what we want this to do. I'll give this my best shot.
                        outputVal = this.toCaptialCase(stringVal);
                        //Any words that are 1 or 2 letters long we will make lower case - this might be a bit overkill, but most 2 letter words I can think of should be lower case
                        //We are also replacing 3 letter conjunctions and the article "the" - there are probably more that could qualify in the 3 letter range, but this is pretty good.
                        outputVal = outputVal.replace(/(\b)(\w{1,2}|And|The|But|For|Nor|Yet)(\b)/g, (_foundVal, before, word, after) => {
                            return `${before}${'I' === word ? word : word.toLowerCase()}${after}`; // Do not lower case the word "I"
                        });
                        outputVal = this.capitalizeAfterPeriods(outputVal);
                        break;
                    default:
                        outputVal = stringVal;
                }
                return { output: outputVal };
            }
            return { output: undefined };
        };
        this._interfaceDefinition = Schema;
    }
    toCaptialCase(str) {
        return str.toLowerCase().replace(/([^a-z']|^)([a-z])/g, (_foundVal, before, letter) => {
            //Capitalize the first letter after any break other than "'"
            return `${before}${letter.toUpperCase()}`;
        });
    }
    capitalizeAfterPeriods(str) {
        return str.replace(/(\.\s+|^\s*)([a-z])/g, (_foundVal, before, letter) => {
            //Make the first word of the string and the first word after a period capitalized
            return `${before}${letter.toUpperCase()}`;
        });
    }
}
exports.ChangeCaseNode = ChangeCaseNode;
ChangeCaseNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Change Case',
    isIdempotent: true,
    primaryCategory: 'Text',
};
//# sourceMappingURL=ChangeCase.js.map